/**
 * Created by mqamhieh on 2/3/18.
 */
(function() {

    "use strict";

    angular.module("formsManager", [
    ]);
})();